import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Bento from "@/components/Bento";
import Ingredients from "@/components/Ingredients";
import Ritual from "@/components/Ritual";
import BeforeAfter from "@/components/BeforeAfter";
import Reviews from "@/components/Reviews";
import OrderForm from "@/components/OrderForm";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";
import AdminOrders from "@/components/AdminOrders";

export default function App() {
  const isAdminPage = window.location.pathname.replace(/\/+$/, "") === "/admin/orders";

  useEffect(() => {
    if (isAdminPage) return;
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, [isAdminPage]);

  if (isAdminPage) {
    return (
      <div dir="rtl" className="min-h-screen bg-[#FBF9F4] text-[#162822]">
        <AdminOrders />
        <Toaster position="top-center" richColors />
      </div>
    );
  }

  return (
    <div dir="rtl" className="min-h-screen overflow-x-clip bg-[#FBF9F4] text-[#162822]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <OrderForm />
        <Bento />
        <Ritual />
        <BeforeAfter />
        <Ingredients />
        <Reviews />
        <Faq />
      </main>
      <Footer />
      <StickyBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}
